"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Unlink1_exports = {};
__export(Unlink1_exports, {
  default: () => Unlink1_default
});
module.exports = __toCommonJS(Unlink1_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.67578 10.25C5.67578 9.58594 5.79948 8.96094 6.04688 8.375C6.29427 7.78906 6.63932 7.27474 7.08203 6.83203C7.52474 6.38932 8.03906 6.04427 8.625 5.79688C9.21094 5.54948 9.83594 5.42578 10.5 5.42578C11.1641 5.42578 11.7891 5.54948 12.375 5.79688C12.9609 6.04427 13.4753 6.38932 13.918 6.83203C14.3607 7.27474 14.7057 7.78906 14.9531 8.375C15.2005 8.96094 15.3242 9.58594 15.3242 10.25C15.3242 10.9141 15.2005 11.5391 14.9531 12.125C14.7057 12.7109 14.3607 13.2253 13.918 13.668C13.4753 14.1107 12.9609 14.4557 12.375 14.7031C11.7891 14.9505 11.1641 15.0742 10.5 15.0742C9.83594 15.0742 9.21094 14.9505 8.625 14.7031C8.03906 14.4557 7.52474 14.1107 7.08203 13.668C6.63932 13.2253 6.29427 12.7109 6.04688 12.125C5.79948 11.5391 5.67578 10.9141 5.67578 10.25ZM10.5 4.41016C9.69271 4.41016 8.9375 4.56641 8.23438 4.87891C7.51823 5.17839 6.89323 5.59505 6.35938 6.12891C5.83854 6.64974 5.42839 7.26823 5.12891 7.98438C4.81641 8.6875 4.66016 9.44271 4.66016 10.25C4.66016 11.0573 4.81641 11.8125 5.12891 12.5156C5.42839 13.2318 5.83854 13.8568 6.35938 14.3906C6.89323 14.9115 7.51823 15.3216 8.23438 15.6211C8.9375 15.9336 9.69271 16.0898 10.5 16.0898C11.3073 16.0898 12.0625 15.9336 12.7656 15.6211C13.4818 15.3216 14.1003 14.9115 14.6211 14.3906C15.1549 13.8568 15.5716 13.2318 15.8711 12.5156C16.1836 11.8125 16.3398 11.0573 16.3398 10.25C16.3398 9.44271 16.1836 8.6875 15.8711 7.98438C15.5716 7.26823 15.1549 6.64974 14.6211 6.12891C14.1003 5.59505 13.4818 5.17839 12.7656 4.87891C12.0625 4.56641 11.3073 4.41016 10.5 4.41016Z",
      fill: "currentColor"
    }
  )
);
const SvgUnlink1 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Unlink1_default = SvgUnlink1;
